import React, { useEffect, useState } from "react";
import music from "../../assests/music.svg";
import InstagramPopup from "../InstagramPopup/InstagramPopup";

function AudioPlayer({ contestDetails, isPlaying, setIsplaying, audioElem }) {
  const [openInSystemBrowser, setOpenInSystemBrowser] = useState(false);
  useEffect(() => {
    if (isPlaying) {
      audioElem.current.play();
    } else {
      audioElem.current.pause();
    }
  }, [isPlaying]);
  const PlayPause = () => {
    setIsplaying(!isPlaying);
  };
  const handleDownload = (file) => {
    if (navigator.userAgent.includes("Instagram")) {
      setOpenInSystemBrowser(true);
    } else {
      fetch(file?.fileUrl)
        .then((response) => response.blob())
        .then((blob) => {
          const url = window.URL.createObjectURL(blob);
          const a = document.createElement("a");
          a.href = url;
          a.download = file?.fileName; // Set the desired filename for download
          a.click();
          window.URL.revokeObjectURL(url);
        });
    }
  };

  return (
    <>
      {openInSystemBrowser && (
        <InstagramPopup
          setPopup={setOpenInSystemBrowser}
          backgroundColor={contestDetails?.buttonColor}
          message="Instagram does not support direct file downloads to your device. Please copy and paste the below provided link into any web browser like Chrome, Safari etc."
        />
      )}
      <div className="flex gap-2">
        <div className=" w-full md:max-w-[540px] bg-[#252525] rounded-full flex items-center justify-between p-[12px]">
          <div className="flex items-center gap-[10px]">
            <div className="h-[33px] w-[33px] bg-[#171717] rounded-full flex  items-center justify-center">
              <img src={music} alt="" className="w-[15px] h-[15px]" />
            </div>
            <p className="text-[14px] text_1Line text-left">
              {contestDetails?.performanceData?.fileName}
            </p>
          </div>
          <div className="flex items-center gap-[10px]">
            <div
              className="h-[33px] w-[33px] bg-[#606060] rounded-full flex items-center justify-center shrink-0 cursor-pointer"
              onClick={PlayPause}
            >
              <audio
                src={contestDetails?.performanceData?.fileUrl}
                ref={audioElem}
              />

              {isPlaying ? (
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="44"
                  height="44"
                  viewBox="0 0 44 44"
                  fill="none"
                >
                  <circle cx="22" cy="22" r="22" fill="#606060" />
                  <path
                    d="M18 13V30M26 13V30"
                    stroke="#EAF0FF"
                    stroke-width="2.5"
                  />
                </svg>
              ) : (
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="33"
                  height="33"
                  viewBox="0 0 33 33"
                  fill="none"
                >
                  <circle cx="16.5" cy="16.5" r="16.5" fill="#606060" />
                  <path d="M13 8L23 16.5029L13 25V8Z" fill="#EAF0FF" />
                </svg>
              )}
            </div>
            <div
              onClick={() => handleDownload(contestDetails?.performanceData)}
              className="cursor-pointer h-[33px] w-[33px] bg-[#606060] rounded-full flex items-center justify-center shrink-0"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="19"
                height="19"
                viewBox="0 0 19 19"
                fill="none"
              >
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M9.5 0C9.86604 0 10.1628 0.296742 10.1628 0.662785V10.3594L11.648 8.62671C11.8861 8.34879 12.3046 8.31662 12.5825 8.55487C12.8604 8.79303 12.8926 9.21147 12.6544 9.4894L10.0032 12.5824C9.87735 12.7293 9.69345 12.8138 9.5 12.8138C9.30655 12.8138 9.12265 12.7293 8.99681 12.5824L6.34561 9.4894C6.10739 9.21147 6.13957 8.79303 6.4175 8.55487C6.69542 8.31662 7.11385 8.34879 7.35206 8.62671L8.83721 10.3594V0.662785C8.83721 0.296742 9.13396 0 9.5 0ZM5.07771 6.18772C5.44375 6.18569 5.74214 6.48077 5.74418 6.84681C5.74622 7.21285 5.45113 7.51124 5.08509 7.51327C4.11874 7.51865 3.43379 7.54375 2.91394 7.63924C2.41304 7.73124 2.1231 7.87901 1.90796 8.0941C1.66338 8.33871 1.50392 8.68212 1.41674 9.3305C1.32699 9.99806 1.32558 10.8827 1.32558 12.1512V13.0349C1.32558 14.3034 1.32699 15.1881 1.41674 15.8557C1.50392 16.5041 1.66338 16.8475 1.90796 17.0921C2.15254 17.3367 2.49594 17.4961 3.14439 17.5833C3.8119 17.673 4.69661 17.6744 5.96512 17.6744H13.0349C14.3034 17.6744 15.1881 17.673 15.8556 17.5833C16.5041 17.4961 16.8474 17.3367 17.092 17.0921C17.3367 16.8475 17.4961 16.5041 17.5833 15.8557C17.673 15.1881 17.6744 14.3034 17.6744 13.0349V12.1512C17.6744 10.8827 17.673 9.99806 17.5833 9.3305C17.4961 8.68212 17.3367 8.33871 17.092 8.0941C16.8769 7.87901 16.587 7.73124 16.0861 7.63924C15.5662 7.54375 14.8812 7.51865 13.9149 7.51327C13.5489 7.51124 13.2538 7.21285 13.2558 6.84681C13.2578 6.48077 13.5563 6.18569 13.9223 6.18772C14.8781 6.19305 15.6746 6.21592 16.3255 6.33548C16.9954 6.45852 17.5655 6.69292 18.0294 7.15681C18.5613 7.68872 18.7901 8.35851 18.897 9.15394C19 9.92003 19 10.8942 19 12.1027V13.0835C19 14.292 19 15.2661 18.897 16.0323C18.7901 16.8277 18.5613 17.4974 18.0294 18.0294C17.4974 18.5613 16.8277 18.7901 16.0323 18.897C15.2661 19.0001 14.292 19 13.0834 19H5.91663C4.70806 19 3.73392 19.0001 2.96776 18.897C2.17231 18.7901 1.50256 18.5613 0.970635 18.0294C0.438706 17.4974 0.20992 16.8277 0.102972 16.0323C-3.48464e-05 15.2661 -1.72114e-05 14.292 4.62975e-07 13.0835V12.1027C-1.72114e-05 10.8942 -3.48464e-05 9.92003 0.102972 9.15394C0.20992 8.35851 0.438706 7.68872 0.970635 7.15681C1.43453 6.69291 2.00459 6.45852 2.67445 6.33548C3.32536 6.21592 4.12194 6.19304 5.07771 6.18772Z"
                  fill="#FDFEFF"
                />
              </svg>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default AudioPlayer;
